import Adjust from './Adjust'
import Arrow from './Arrow'
import ArrowsLeftRight from './ArrowsLeftRight'
import ArrowsOut from './ArrowsOut'
import Bolt from './Bolt'
import Briefcase from './Briefcase'
import Chevron from './Chevron'
import ChevronBold from './ChevronBold'
import Close from './Close'
import ClipboardLines from './ClipboardLines'
import ClipboardPlus from './ClipboardPlus'
import DeliveryTruck from './DeliveryTruck'
import Enlarge from './Enlarge'
import Email from './Email'
import Headset from './Headset'
import Home from './Home'
import List from './List'
import Location from './Location'
import LocationPin from './LocationPin'
import LocationPinSimple from './LocationPinSimple'
import MeasuringTape from './MeasuringTape'
import PieChart from './PieChart'
import Plane from './Plane'
import Play from './Play'
import Pause from './Pause'
import Phone from './Phone'
import Search from './Search'
import ShoppingBasket from './ShoppingBasket'
import Stethoscope from './Stethoscope'
import Users from './Users'
import Wallet from './Wallet'
import Wheelbarrow from './Wheelbarrow'
import Wrench from './Wrench'

export type IconType =
	| 'Adjust'
	| 'Arrow'
	| 'ArrowsLeftRight'
	| 'ArrowsOut'
	| 'Briefcase'
	| 'Bolt'
	| 'Chevron'
	| 'ChevronBold'
	| 'Close'
	| 'ClipboardLines'
	| 'ClipboardPlus'
	| 'DeliveryTruck'
	| 'Enlarge'
	| 'Email'
	| 'Headset'
	| 'Home'
	| 'List'
	| 'Location'
	| 'LocationPin'
	| 'LocationPinSimple'
	| 'MeasuringTape'
	| 'PieChart'
	| 'Plane'
	| 'Play'
	| 'Pause'
	| 'Phone'
	| 'Search'
	| 'ShoppingBasket'
	| 'Stethoscope'
	| 'Users'
	| 'Wallet'
	| 'Wheelbarrow'
	| 'Wrench'

interface IconProps extends React.SVGProps<SVGSVGElement> {
	icon: IconType
}

const icons = {
	Adjust,
	Arrow,
	ArrowsLeftRight,
	ArrowsOut,
	Bolt,
	Briefcase,
	Chevron,
	ChevronBold,
	Close,
	ClipboardLines,
	ClipboardPlus,
	DeliveryTruck,
	Enlarge,
	Email,
	Headset,
	Home,
	List,
	Location,
	LocationPin,
	LocationPinSimple,
	MeasuringTape,
	PieChart,
	Plane,
	Play,
	Pause,
	Phone,
	Search,
	ShoppingBasket,
	Stethoscope,
	Users,
	Wallet,
	Wheelbarrow,
	Wrench,
}

export default function Icon({ icon, ...props }: IconProps) {
	const Component = icons[icon]
	return <Component {...props} />
}
